import { BookOpen, Loader2, Plus, Users } from "lucide-react";
import { useState } from "react";
import type { DeskStepProps } from "./welcome-onboarding-types";

type DeskMode = "pic" | "create";

export function WelcomeDeskStep({
  busy,
  isBusy,
  onCreateDesk,
  onJoinPic,
  profile,
}: DeskStepProps) {
  const [mode, setMode] = useState<DeskMode>("pic");
  const [deskName, setDeskName] = useState(
    profile.deskName && profile.deskName !== "Priced In Capital"
      ? profile.deskName
      : "",
  );
  const canCreate = deskName.trim().length > 1;
  return (
    <section
      className="welcome-onboarding__panel welcome-onboarding__panel--stack"
      aria-label="Desk setup"
    >
      <div className="welcome-onboarding__choice-grid">
        <button
          className={`welcome-onboarding__choice-card ${
            mode === "pic" ? "is-active" : ""
          }`}
          onClick={() => setMode("pic")}
          type="button"
        >
          <Users size={18} strokeWidth={1.8} />
          <strong>Join Priced In Capital</strong>
          <span>Default beta desk.</span>
        </button>
        <button
          className={`welcome-onboarding__choice-card ${
            mode === "create" ? "is-active" : ""
          }`}
          onClick={() => setMode("create")}
          type="button"
        >
          <BookOpen size={18} strokeWidth={1.8} />
          <strong>Create desk</strong>
          <span>Start a private desk.</span>
        </button>
      </div>

      {mode === "create" ? (
        <label className="welcome-onboarding__single-field">
          <span>Desk name</span>
          <input
            value={deskName}
            onChange={(event) => setDeskName(event.target.value)}
            placeholder="My desk"
          />
        </label>
      ) : null}

      <button
        className="welcome-onboarding__btn welcome-onboarding__btn--primary"
        disabled={isBusy || (mode === "create" && !canCreate)}
        onClick={() =>
          mode === "pic" ? onJoinPic() : onCreateDesk(deskName.trim())
        }
        type="button"
      >
        {busy === "saving" ? (
          <Loader2 size={16} strokeWidth={2.1} className="spin" />
        ) : mode === "create" ? (
          <Plus size={16} strokeWidth={2.1} />
        ) : (
          <Users size={16} strokeWidth={2.1} />
        )}
        <span>{mode === "pic" ? "Continue" : "Create Desk"}</span>
      </button>
    </section>
  );
}
